import { type ColumnDef } from '@tanstack/react-table';

import { type ColumnVisibility } from '../types';

const getVisibilityColumns = <TData>(
  columns: ColumnDef<TData>[],
): ColumnVisibility[] => {
  return columns.map(column => ({
    label: typeof column.header === 'string' ? column.header : '',
    key: column.id ?? '',
    hide: false,
  }));
};

export { getVisibilityColumns };
